export default {
  main: '#45AAB6',
  secondary: '#EDA22A',
  contrastingColor: '#ffffff',
  priceColor: '#45AAB6',
  entryBackground: '#45AAB6',
  menuBackgroundColor: '#ffffff',
  menuTextColor: '#000000',
};
